import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bangkok/scan-qr.png")